module.exports = __webpack_public_path__ + "assets/pdf/cabernet-syrah.d30c8f76.pdf";